import type { Policy, VisionPillar } from '../types'

export const visionPillars: VisionPillar[] = [
  {
    title: 'A Productive Nigeria',
    description:
      'Move the economy from consumption to production: manufacturing, agro-processing and export capacity that create formal jobs.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e030d895-eee3-4d0c-845b-c8f441936969.jpg',
  },
  {
    title: 'A Secure Nigeria',
    description:
      'Restore safety on the roads, on the farms and in the classrooms through intelligence-led, community-anchored policing.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/93340211-d03b-4760-9807-29ce94192f52.jpg',
  },
  {
    title: 'An Educated Nigeria',
    description:
      'Every Nigerian child in school, learning — with teachers paid on time and technical education treated as a first choice.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/db019d07-84c7-4add-8953-0634ea68b0d3.jpg',
  },
  {
    title: 'A Healthy Nigeria',
    description:
      'A functioning primary healthcare centre in every ward, and health insurance that ordinary families can actually use.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/20eced12-a4a9-46f7-8597-99c0c458533b.jpg',
  },
  {
    title: 'A Powered Nigeria',
    description:
      '24-hour electricity as a national standard, delivered through grid reform, gas-to-power and distributed renewables.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/78758787-cb47-4c4a-80e5-daa7f359f8d3.jpg',
  },
  {
    title: 'A Globally Competitive Nigeria',
    description:
      'A digital economy and diaspora partnership that lets Nigerian talent build world-class companies from home.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/bd5404b8-d7a4-46e6-9892-2f8d1b841d5a.jpg',
  },
]

export const policyFilters = [
  'All',
  'Economy',
  'Human Development',
  'Security',
  'Infrastructure',
  'Governance',
]

export const policies: Policy[] = [
  {
    title: 'Economy & Jobs',
    slug: 'economy-and-jobs',
    category: 'Economy',
    summary:
      'Five million formal jobs in four years through manufacturing clusters, MSME credit and a stable exchange-rate regime.',
    icon: 'briefcase',
  },
  {
    title: 'Security & Justice',
    slug: 'security',
    category: 'Security',
    summary:
      'State-level policing under a national standard, forensic capability, and faster prosecution of violent crime.',
    icon: 'shield',
  },
  {
    title: 'Power & Energy',
    slug: 'power-and-energy',
    category: 'Infrastructure',
    summary:
      'Fix metering and transmission first, then add 12,000MW of dispatchable and renewable generation.',
    icon: 'zap',
  },
  {
    title: 'Education',
    slug: 'education',
    category: 'Human Development',
    summary:
      'Teacher pay reform, 10,000 renovated schools and a technical education pathway with guaranteed placement.',
    icon: 'graduation',
  },
  {
    title: 'Healthcare',
    slug: 'healthcare',
    category: 'Human Development',
    summary:
      'Revitalise 8,800 primary healthcare centres and extend insurance coverage to 60 million Nigerians.',
    icon: 'heart',
  },
  {
    title: 'Agriculture & Food',
    slug: 'agriculture',
    category: 'Economy',
    summary:
      'Secure the farmlands, mechanise smallholder production and cut post-harvest losses with cold-chain investment.',
    icon: 'sprout',
  },
  {
    title: 'Digital Economy',
    slug: 'digital-economy',
    category: 'Economy',
    summary:
      'Broadband to every LGA, a national skills fund, and procurement that favours Nigerian-built software.',
    icon: 'cpu',
  },
  {
    title: 'Infrastructure & Transport',
    slug: 'infrastructure',
    category: 'Infrastructure',
    summary:
      'Complete stalled rail and road corridors under a transparent, independently audited delivery unit.',
    icon: 'road',
  },
  {
    title: 'Governance & Accountability',
    slug: 'governance',
    category: 'Governance',
    summary:
      'Open contracting by default, a leaner cost of governance, and published performance targets for every minister.',
    icon: 'scale',
  },
]
